import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import {
  PeoDetailBillingPage,
  PeoDetailEmployeesPage,
  PeoDetailEmployersPage,
  PeoDetailLiveStatusPage,
  PeoDetailSettingsPage,
  PeoDetailStaffPage,
  PeosPage,
} from 'src/pages/peos';
import { PeoDetailCompanyInformationPage } from 'src/pages/peos/PeoDetailCompanyInformationPage';
import { RouteProps } from 'src/types/router';

import { PeosDetailOutlet } from './components';

const ROUTES = [
  {
    index: true,
    element: <PeosPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.peos.detail.index,
    element: <PeosDetailOutlet />,
    childRoutes: [
      {
        path: appRoutes.peos.detail.companyInformation,
        element: <PeoDetailCompanyInformationPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peos.detail.billing,
        element: <PeoDetailBillingPage />,
        accessRoles: [ReactRouteAccessKey.hasPlatformRoles],
      },
      {
        path: appRoutes.peos.detail.staff,
        element: <PeoDetailStaffPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peos.detail.employers,
        element: <PeoDetailEmployersPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peos.detail.employees,
        element: <PeoDetailEmployeesPage />,
        accessRoles: [ReactRouteAccessKey.inherit, ReactRouteAccessKey.isNotPartnershipCompanyUser],
      },
      {
        path: appRoutes.peos.detail.settings,
        element: <PeoDetailSettingsPage />,
        accessRoles: [ReactRouteAccessKey.inherit],
      },
      {
        path: appRoutes.peos.detail.liveStatus,
        element: <PeoDetailLiveStatusPage />,
        accessRoles: [ReactRouteAccessKey.isPlatformAdmin],
      },
    ],
    accessRoles: [ReactRouteAccessKey.inherit],
  },
] as const satisfies RouteProps[];

export const PEOS_ROUTE = {
  path: appRoutes.peos.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.hasPlatformRoles, ReactRouteAccessKey.isPeoPayrollProviderUser],
} as const satisfies RouteProps;
